import { useState, useEffect } from "react";
import { useStudioErstellen } from "../../store/studioErstellenStore";

import classes from "./StudioTitle.module.css";
import ErrorMessage from "./ErrorMessage";

export const FourthStep = ({ validate }) => {
  const { studioData, updateStudioData } = useStudioErstellen();
  const [text, setText] = useState(studioData.StudioName || '');
  const [errors, setErrors] = useState({
    StudioName: "",
  });

  const MAX_LENGTH = 40;

  const handleValidation = () => {
    if (text.trim() === "") {
      setErrors({ StudioName: "Titel muss ausgefüllt werden" });
      return false;
    }
    
    // Check if text contains only numbers
    if (/^\d+$/.test(text.trim())) {
      setErrors({ StudioName: "Titel darf nicht nur aus Zahlen bestehen" });
      return false;
    }
    
    // Count letters in the text
    const letterCount = (text.match(/[a-zA-ZäöüÄÖÜß]/g) || []).length;
    if (letterCount < 6) {
      setErrors({ StudioName: "Titel muss mindestens 6 Buchstaben enthalten" });
      return false;
    }
    
    if (text.length > MAX_LENGTH) {
      setErrors({ StudioName: `Titel darf maximal ${MAX_LENGTH} Zeichen haben` });
      return false;
    }

    return true;
  };

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setText(inputValue);
    updateStudioData('StudioName', inputValue);

    if (inputValue.length > MAX_LENGTH) {
      setErrors({ StudioName: `Titel darf maximal ${MAX_LENGTH} Zeichen haben` });
    } else {
      setErrors({ StudioName: "" });
    }
  };

  useEffect(() => {
    validate.current = handleValidation;
  }, [text]);

  const getStudioTypeText = () => {
    const types = Array.isArray(studioData?.studioTypes) ? studioData.studioTypes : [];
    
    if (types.length === 0) {
      return { example: 'Beispiel: Industrielles Fotostudio mit Tageslicht', question: 'Was macht dein Studio besonders?' };
    }

    const typeMap = {
      'Foto': 'Foto',
      'Video': 'Video',
      'Musik': 'Musik'
    };

    const sortedTypes = types
      .filter(type => typeMap[type])
      .sort((a, b) => {
        const order = ['Foto', 'Video', 'Musik'];
        return order.indexOf(a) - order.indexOf(b);
      });

    if (sortedTypes.length === 0) {
      return { example: 'Beispiel: Industrielles Fotostudio mit Tageslicht', question: 'Was macht dein Studio besonders?' };
    }

    let studioTypeText = '';
    if (sortedTypes.length === 1) {
      const type = sortedTypes[0];
      if (type === 'Musik') {
        studioTypeText = 'Musik- und Tonstudio';
      } else {
        studioTypeText = `${type}studio`;
      }
    } else if (sortedTypes.length === 2) {
      const [first, second] = sortedTypes;
      if (second === 'Musik') {
        studioTypeText = `${first}- und Musikstudio`;
      } else {
        studioTypeText = `${first}- und ${second}studio`;
      }
    } else {
      const [first, second, third] = sortedTypes;
      if (third === 'Musik') {
        studioTypeText = `${first}-, ${second}- und Musikstudio`;
      } else {
        studioTypeText = `${first}-, ${second}- und ${third}studio`;
      }
    }

    const exampleText = `Beispiel: Professionelles ${studioTypeText}`;
    const questionText = `Was macht dein ${studioTypeText} besonders?`;

    return { example: exampleText, question: questionText };
  };

  const { example, question } = getStudioTypeText();

  return (
    <div className={classes.mainContainer}>
        <h2 className={`${classes.title} titleSemibold`}>Erstelle einen Titel für dein Studio.</h2>
        <div className={classes.textContainer}>
            <span className="slimRegularLarge">{example}</span>
            <span className="slimRegularLarge">{question}</span>
        </div>
        <div className={classes.inputContainer}>
            <textarea
                type="text"
                className={`${classes.input} ${text.length > MAX_LENGTH ? classes.inputError : ""} slimRegularLargeText`}
                placeholder={example}
                value={text}
                onChange={handleInputChange}
            />
            <div className={`${classes.textLength} slimRegularMiniText`}>
                {text.length}/40
                {errors.StudioName && <ErrorMessage>{errors.StudioName}</ErrorMessage>}
            </div>
        </div>
    </div>
  );
};

export default FourthStep;
